import React from 'react';

import Client from './components/Client';
import Config from './components/ClientConfig';

class Forbidden extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      client: new Client ( "none" )
    };
  }
  
  componentDidMount() {
    window.addEventListener("resize", this.resize.bind(this));
    this.resize();
  }

  resize() {
    this.setState({hideSideBar: window.innerWidth <= 760});
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.resize.bind(this));
  }

  render() {

    return (
      <div style={{ backgroundColor: "#273442", height: "100vh" }}>
        <p>Forbidden</p>
      </div>
    );
  }
}

export default Forbidden;